import apiCliente from '../utils/apiCliente';
import { toast } from 'react-toastify';

/**
 * Actualiza manualmente las credenciales de Instagram
 * @param {Object} credentials - Credenciales de Instagram
 * @param {string} credentials.user_id - User ID de Instagram
 * @param {string} credentials.access_token - Access Token de Instagram
 * @param {Function} dispatch - Redux dispatch function
 * @returns {Promise<Object>} Resultado de la actualización
 */
export const actualizarInstagramCredenciales = async (credentials, dispatch) => {
	try {
		const token = sessionStorage.getItem('token');

		if (!token) {
			toast.error('No hay sesión activa');
			throw new Error('No hay sesión activa');
		}

		if (!credentials.user_id || !credentials.access_token) {
			toast.error('User ID y Access Token son requeridos');
			throw new Error('User ID y Access Token son requeridos');
		}

		const response = await apiCliente.put('/instagram-token/update', credentials, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		toast.success('Credenciales de Instagram actualizadas exitosamente');
		return response.data;
	} catch (error) {
		console.error('Error al actualizar credenciales de Instagram:', error);

		if (error.response?.status === 401) {
			toast.error('Sesión expirada. Por favor, inicia sesión nuevamente.');
			window.location.href = '/login';
		} else if (error.response?.status === 400) {
			toast.error(error.response.data.error || 'Token inválido. Verifica las credenciales.');
		} else {
			toast.error(error.response?.data?.error || 'Error al actualizar credenciales de Instagram');
		}

		throw new Error(error.response?.data?.error || 'Error al actualizar credenciales de Instagram');
	}
};
